import { render, staticRenderFns } from "./CustomerProfile.htm?vue&type=template&id=0dc82164&scoped=true&"
import script from "./CustomerProfile.ts?vue&type=script&lang=js&"
export * from "./CustomerProfile.ts?vue&type=script&lang=js&"
import style0 from "./CustomerProfile.scss?vue&type=style&index=0&id=0dc82164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc82164",
  null
  
)

export default component.exports